export const AXP_CLIENT_TEALEAF_URL_US = 'tealeafUrlUS';
export const AXP_CLIENT_TEALEAF_URL_INTL = 'tealeafUrlIntl';
